var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 28, height: 28, viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M14 6V4.508L10 7l4 2.498V8c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0022 14c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L7.24 9.74A7.93 7.93 0 006 14c0 4.42 3.58 8 8 8v1.4l4-2.4-4-2.584V20z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
